import {
  Lit3formBlock,
  html,
  classMap,
  unsafeHTML,
} from '@Root/lib/lit-3form-block';
import { styles } from './css';

export class Bill extends Lit3formBlock {
  static get characterName() {
    return 'bill';
  }

  static get characterProperties() {
    return {
      text: { type: String },
      justification: { type: String },
      size: { type: String },
      italics: { type: Number },
      elements_colors: { type: Number },
      start_column: { type: Number },
      end_column: { type: Number },
    };
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div id="bill-block" class="bill-layout block-grid">
          <div
            class="${classMap(this.wrapperClasses)}"
            style="${this.positionWrapperStyle}"
          >
            <div
              class="${classMap(this.gridClasses)}"
              style="${this.textWrapperStyle}"
            >
              ${this.textHtml} ${this.attributionHtml}
            </div>
          </div>
          ${this.showHorizontalRule}
        </div>
      </div>
    `;
  }

  get wrapperClasses() {
    const classObject = {
      'position-wrapper': true,
    };

    classObject['elements-colors'] = this.elementsColors;
    classObject[`grid-${this.justification}`] = true;

    return classObject;
  }

  get gridClasses() {
    const classObject = {
      'text-wrapper': true,
    };
    classObject['italics'] = this.italics;

    return classObject;
  }

  get textHtml() {
    switch (this.fontSize) {
      case 'small':
        return html`
          <p class="font-size-small">${this.textString}</p>
        `;
      case 'normal':
        return html`
          <p>${this.textString}</p>
        `;
      case 'medium':
        return html`
          <p class="font-size-medium">${this.textString}</p>
        `;
      case 'large':
        return html`
          <h2>${this.textString}</h2>
        `;
    }
  }

  get attributionHtml() {
    return this.quoteAttributionString
      ? html`
          <p class="font-size-small attribution">
            ${this.quoteAttributionString}
          </p>
        `
      : html``;
  }

  get textString() {
    return unsafeHTML(this.withLineBreaks(this.content.text)) || '';
  }

  get quoteAttributionString() {
    return this.content.quote_attribution
      ? unsafeHTML(this.withLineBreaks(this.content.quote_attribution))
      : '';
  }

  get fontSize() {
    return this.content.size || '';
  }

  get justification() {
    return this.content.justification || 'left';
  }

  get italics() {
    return this.content.italics && this.content.italics == '1';
  }

  get elementsColors() {
    return this.content.elements_colors && this.content.elements_colors == '1';
  }

  get startColumn() {
    return this.parseColumn(this.content.start_column);
  }

  get endColumn() {
    return this.parseColumn(this.content.end_column);
  }

  parseColumn(value) {
    if (value === undefined || value === null || value === '') return null;
    const parsed = parseInt(value, 10);
    return isNaN(parsed) ? null : parsed;
  }

  get hasCustomColumns() {
    const start = this.startColumn;
    const end = this.endColumn;
    return (
      start !== null &&
      end !== null &&
      start >= 1 &&
      start <= 11 &&
      end >= 2 &&
      end <= 12 &&
      end > start
    );
  }

  get positionWrapperStyle() {
    if (!this.hasCustomColumns) return '';
    const gridStart = this.startColumn + 1;
    const gridEnd = this.endColumn + 2;
    return `--bill-grid-column-start: ${gridStart}; --bill-grid-column-end: ${gridEnd};`;
  }

  get textWrapperStyle() {
    return this.hasCustomColumns ? '--bill-text-wrapper-width: 100%;' : '';
  }

  get showHorizontalRule() {
    return this.elementsColors ? html`` : this.horizontalRule;
  }
}
Bill.defineElement();
